import {
  Box,
  Flex,
  Select,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Input,
  Button,
} from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getMonthlyReportRef } from "../../../Http/Index"
import { RefEntry } from "../MonthlyReport.hook"

const CATEGORIES = ["ITES", "Insurance", "BFSI", "Field, Sales & Mfg", "Others"]

export const RefTable: React.FC = () => {
  const [data, setData] = useState<RefEntry[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [categoryFilter, setCategoryFilter] = useState("")
  const [activeFilter, setActiveFilter] = useState("")

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const res = await getMonthlyReportRef()
      setData(res.data?.data || [])
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  const filtered = data.filter((r) => {
    const matchSearch =
      !search ||
      r.companyName.toLowerCase().includes(search.toLowerCase()) ||
      r.client.toLowerCase().includes(search.toLowerCase())
    const matchCategory = !categoryFilter || r.category === categoryFilter
    const matchActive =
      activeFilter === "" ||
      (activeFilter === "true" && r.isActivePartnership) ||
      (activeFilter === "false" && !r.isActivePartnership)
    return matchSearch && matchCategory && matchActive
  })

  const clearFilters = () => {
    setSearch("")
    setCategoryFilter("")
    setActiveFilter("")
  }

  return (
    <Box>
      <Flex gap={3} mb={3} wrap="wrap" align="center">
        <Input
          size="sm"
          w="200px"
          placeholder="Search company..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Select size="sm" w="180px" placeholder="All Categories" value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}>
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </Select>

        <Select size="sm" w="160px" placeholder="All Partnerships" value={activeFilter}
          onChange={(e) => setActiveFilter(e.target.value)}>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </Select>

        {(search || categoryFilter || activeFilter) && (
          <Button size="sm" variant="ghost" colorScheme="red" onClick={clearFilters}>Clear</Button>
        )}

        <Text fontSize="sm" color="gray.500" ml="auto">{filtered.length} companies</Text>
      </Flex>

      {isLoading ? (
        <Flex justify="center" py={10}><Spinner /></Flex>
      ) : filtered.length === 0 ? (
        <Text color="gray.400" textAlign="center" py={6}>No data</Text>
      ) : (
        <Box overflowX="auto" borderWidth={1} borderRadius="md">
          <Table size="sm" variant="simple">
            <Thead bg="gray.100">
              <Tr>
                <Th>#</Th>
                <Th>Company Name</Th>
                <Th>Category</Th>
                <Th>Partnership</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filtered.map((row, i) => (
                <Tr key={row._id} _hover={{ bg: "gray.50" }}>
                  <Td>{i + 1}</Td>
                  <Td fontWeight="medium">{row.companyName}</Td>
                  <Td>
                    <Badge colorScheme={
                      row.category === "ITES" ? "purple" :
                      row.category === "Insurance" ? "green" :
                      row.category === "BFSI" ? "orange" :
                      row.category === "Field, Sales & Mfg" ? "teal" : "gray"
                    }>
                      {row.category}
                    </Badge>
                  </Td>
                  <Td>
                    <Badge colorScheme={row.isActivePartnership ? "green" : "red"}>
                      {row.isActivePartnership ? "Active" : "Inactive"}
                    </Badge>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  )
}
